import { getCustomProps, getNotCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface ContractTypes {
  code: string
  name: string
  country_id: string
}

export async function getContractTypes(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['country_id=:countryId']
  if (search) {
    where.push(`CONCAT(name,code) ILIKE '%${search}%'`)
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS NUMERIC) ELSE NULL END), code"
      ])

  // result
  const response: any = await getData({
    tables: ['pg_contract_types'],
    fields: ['name', 'code', 'updated_at'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getContractType(id: string): Promise<ContractTypes> {
  const data = await getData<any>({
    tables: ['pg_contract_types'],
    fields: ['id', 'code', 'name', 'updated_at'],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createContractType(data: any): Promise<boolean> {
  const response: any = await http.post('country/contract-types', {
    ...getNotCustomProps(data),
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateContractType(
  data: ContractTypes,
  id: string
): Promise<boolean> {
  const response: any = await http.put('country/contract-types/' + id, {
    ...getNotCustomProps(data),
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
